import { triggerHaptic } from "@/lib/nativeHaptics";
import { trackEvent } from "@/lib/analytics";

export function SavedEmptyAuth({ onGoHome }: { onGoHome: () => void }) {
  return (
    <div
      style={{
        background: "#FFFCF8",
        border: "0.5px solid #E8E2D9",
        borderRadius: 20,
        padding: "36px 20px",
        marginTop: 60,
        textAlign: "center",
      }}
    >
      <i
        className="ti ti-bookmark"
        style={{ fontSize: 36, color: "#9B958E" }}
        aria-hidden="true"
      />
      <h2
        className="l2f-type-h2"
        style={{ marginTop: 10, color: "#2C2820" }}
      >
        No saved looks yet
      </h2>
      <p
        className="l2f-type-secondary"
        style={{ marginTop: 8, color: "#6B6560" }}
      >
        Tap the bookmark icon on any outfit to keep it here.
      </p>
      <button
        type="button"
        onClick={() => {
          void triggerHaptic("tab-switch");
          trackEvent("saved_empty_cta_tapped", { variant: "auth_try_outfit" });
          onGoHome();
        }}
        style={{
          marginTop: 14,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 6,
          padding: "8px 14px",
          minHeight: 44,
          background: "#F1EFE8",
          border: "none",
          borderRadius: 16,
          cursor: "pointer",
          color: "#4A4540",
          fontSize: 13,
          fontWeight: 500,
        }}
      >
        <i
          className="ti ti-arrow-up"
          style={{ fontSize: 12, color: "#4A4540" }}
          aria-hidden="true"
        />
        Try analysing an outfit
      </button>
    </div>
  );
}
